import { useNavigate } from 'react-router-dom';

import { simpleConfirmDialog } from '../../../../actions/swal_msg';

import { Fab } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const BranchFAB = ({ values }) => {
    const navigate = useNavigate();

    const checkChanges = async () => {
        const {
            links: { whatsapp: { number }, facebook: { url },
            google_maps: { placeId } }, businessHours, ...rest
        } = values;

        const fullForm = { number, url, placeId, ...rest };
        
        // hubo cambios en formulario
        const hasContent = Object.values(fullForm).some(value => value !== "");
        if (!hasContent)
            return navigate('/nefro-admin/sucursales');
        
        if (await simpleConfirmDialog(
            'No ha guardado la sucursal, ¿descartar?', 'Sí, salir', true
        ))
            navigate('/nefro-admin/sucursales');
    };

    return (
        <Fab
            color="primary"
            sx={{
                position: "fixed",
                bottom: '35px',
                right: '35px',
                '&:hover': {
                    color: '#fff',
                }
            }}
            onClick={checkChanges}
        >
            <ArrowBackIcon />
        </Fab>
    );
};

export default BranchFAB;
